import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetForm as GetFormQuery,
    GetFormVariables as GetFormQueryVariables,
    FormFragment as Form,
} from 'nutshell-graphql-types';

import GET_FORM from '../queries/get-form.graphql';

type Props = {
    formId: string;
    children: (arg1: {
        form: Form | null | undefined;
        isLoading: boolean;
        error: string | null | undefined;
        refetch: () => Promise<any>;
    }) => React.ReactElement;
};

export function FormQuery(props: Props) {
    const {data, error, networkStatus, refetch} = useQuery<GetFormQuery, GetFormQueryVariables>(
        GET_FORM,
        {
            variables: {formId: props.formId},
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
        }
    );

    const form = data ? data.form : null;

    return props.children({
        form,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: isFirstLoad(networkStatus),
        refetch,
    });
}
